var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 22,
    viewBox: "0 0 81 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8607 3.1434C82.0513 7.33395 82.0513 14.1282 77.8607 18.3187C74.6437 21.5357 69.8923 22.2831 65.9623 20.5608L60.3663 26.1568C62.3722 30.1742 61.7002 35.188 58.3503 38.5379C54.1597 42.7284 47.3655 42.7284 43.1749 38.5379C39.9577 35.3207 39.2105 30.5688 40.9331 26.6387L35.042 20.7476C32.3018 21.9475 29.1625 21.947 26.4226 20.7461L20.5603 26.6084C22.2833 30.5387 21.5361 35.2908 18.3187 38.5082C14.1282 42.6987 7.33395 42.6987 3.1434 38.5082C-1.04715 34.3176 -1.04715 27.5234 3.1434 23.3329C6.36032 20.1159 11.1116 19.3685 15.0415 21.0906L20.9044 15.2277C19.182 11.2977 19.9293 6.54601 23.1464 3.3289C27.3369 -0.861646 34.1312 -0.861646 38.3217 3.3289C41.5398 6.54696 42.2866 11.3004 40.5621 15.2312L46.4515 21.1206C49.0263 19.9921 51.9536 19.9237 54.5711 20.9154L60.4437 15.0428C58.7209 11.1126 59.4681 6.36068 62.6854 3.1434C66.8759 -1.04715 73.6702 -1.04715 77.8607 3.1434Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.6ecee1e53d19e4f79adba4cfdf9aab37.svg";
export { ForwardRef as ReactComponent };